import React from "react";
import { periods } from "_constants";
import cx from "classnames";
import PropTypes from "prop-types";

import TitledDropdown from "components/TitledDropdown";
import Translate from "utils/translate";

import styles from "./Period.css";

const { t } = new Translate();

const Period = ({ isBlack, isEdit, onSelect, period, separator }) => (
  <div className={styles.root}>
    {isEdit ? (
      <TitledDropdown
        onSelect={(p) => (onSelect ? onSelect(p) : null)}
        selectedValue={period}
        unitSize={8}
        valueExtractor={(p) => t(`units.${p}`)}
        values={Object.keys(periods)}
        isEdit
      />
    ) : (
      <div className={cx(styles.label, { [styles.black]: isBlack })}>
        {period && <span className={styles.separator}>{separator}</span>}
        {period && <span>{t(`units.${period}`)}</span>}
      </div>
    )}
  </div>
);

Period.propTypes = {
  period: PropTypes.string,
  separator: PropTypes.string,
  onSelect: PropTypes.func,
  isBlack: PropTypes.bool,
  isEdit: PropTypes.bool,
};

Period.defaultProps = {
  separator: "/",
};

export default Period;
